<template>
  <div>
    <el-dialog :title="$i18.language('在线付费')" :visible.sync="dialogVisible" top="10%" width="504px" @close="close">
      <div v-if="paySuccess" class="pay-success">
        <p><svg-icon name="paySuccess" style="font-size: 48px"></svg-icon></p>
        <p>{{ $i18.language('支付完成') }}</p>
        <p class="pay">
          <el-button type="primary" class="confirm-btn" @click="close">{{ $i18.language('确认') }}</el-button>
        </p>
      </div>
      <div v-else>
        <div class="chat-pay-title">{{ $i18.language('该在线服务，不支持退款') }}</div>
        <div class="chat-pay-cont">
          <p>{{ $i18.language('订单号：') }}{{ payData.orderNo }}</p>
          <p>{{ $i18.language('购买产品：小易AIPro提问包') }}</p>
          <p><img style="width: 169px" :src="payData.payUrl" /></p>
          <p>{{ $i18.language('请用微信扫码支付') }}</p>
          <!-- <p>{{ $i18.language('订单号：') }}订单剩余有效时间：00:15:00</p> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'chatPay',
  props: {
    price: {
      type: Number,
    },
  },
  data() {
    return {
      dialogVisible: false,
      paySuccess: false,
      payData: {},
      interval: null,
    }
  },
  mounted() {},
  methods: {
    //创建定时器
    createdInterval() {
      this.interval = setInterval(() => {
        this.refreshStatus()
      }, 1000)
    },
    close() {
      this.dialogVisible=false;
      this.paySuccess=false
      if(this.interval){
        clearInterval(this.interval)
      }
    },
    refreshStatus() {
      const params = {
        orderNo: this.payData.orderNo,
      }
      this.$api.public.refresh(params).then((res) => {
        if (res.data.payStatus === 2) {
          this.paySuccess = true
          this.$emit('chatTable')
          // this.$refs.chatView.getResponse(0, 1)
          clearInterval(this.interval)
        }
      })
    },
    getPayCode() {
      let params = {
        paymentType: 1,
        amount: this.price,
        status: 19,
      }
      this.$api.public.rechargeCode(params).then((res) => {
        if (res && res.code == 200) {
          this.payData = res.data
          //开启定时器
          this.interval = setInterval(() => {
            this.refreshStatus()
          }, 1000)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-pay-title {
  font-size: 14px;

  color: #ea5519;
  margin-bottom: 30px;
}
.chat-pay-cont {
  width: 405px;
  text-align: center;
  margin: 0 auto;
  font-size: 14px;
  font-weight: 400;
  color: #1a173b;
  > p > span:nth-child(1) {
    margin-right: 16px;
  }
  > p {
    margin-top: 10px;
  }
}
.pay-success {
  width: 405px;
  height: 280px;
  margin: 0 auto;
  > p {
    width: 100%;
    text-align: center;
  }
  > p:nth-child(1) {
    margin-top: 56px;
    margin-bottom: 42px;
  }
  > p:nth-child(2) {
    font-size: 19px;
    color: #333333;
    font-weight: 500;
    margin-bottom: 30px;
  }
}
</style>
